import TreatmentProtocolForm from './TreatmentProtocolForm';

export default TreatmentProtocolForm;
